export const SHIPPING_REGIONS_BY_COUNTRY = {
  GB: [
    { value: "England", translationKey: "england" },
    { value: "Scotland", translationKey: "scotland" },
    { value: "Wales", translationKey: "wales" },
  ],
} as const;

export type TShippingCountryWithRegions = keyof typeof SHIPPING_REGIONS_BY_COUNTRY;

const DEFAULT_SHIPPING_COUNTRY: TShippingCountryWithRegions = "GB";

export const getShippingRegionsForLocale = (locale: string) => {
  const country = new Intl.Locale(locale).region;

  if (country && country in SHIPPING_REGIONS_BY_COUNTRY) {
    return SHIPPING_REGIONS_BY_COUNTRY[
      country as TShippingCountryWithRegions
    ];
  }

  return SHIPPING_REGIONS_BY_COUNTRY[DEFAULT_SHIPPING_COUNTRY];
};
